import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { useQueryParams } from '@mote/helpers'
import { useProductsQuery } from '@mote/api'
import NON_IDEAL_STATE_SVG from '@mote/ui/components/nonIdealState/non-ideal-state.svg'
import { OnboardingLayout } from '../../layouts'
import { MessageCard } from '../Onboarding/components'
import { ProductData } from './product.data'

export const CheckoutRedirectScreen = () => {
  const [state, setState] = React.useState({
    loading: true,
    success: false,
    error: null
  })
  const [products, setProducts] = React.useState(new ProductData(null, {}))
  const history = useHistory()
  const { queryParams } = useQueryParams()
  const {
    data: rawProducts,
    loading: isRawProductsLoading,
    error: rawProductsError
  } = useProductsQuery()
  const messageCardProps = React.useMemo(() => {
    if (state.loading || state.success) {
      const props = {
        title: 'Hold on',
        message: 'While we are tranferring you to the checkout page...',
        loading: true,
        showTextOnLoading: true
      }

      if (state.success) {
        props.title = 'Hold tight'
        props.message = 'We are transferring you to the checkout page now!'
      }

      return props
    }

    return {
      title: 'Oh no!',
      message: (
        <>
          An unknown error occurred. If the problem persists kindly contact{' '}
          <Link href='mailto:support@mote.com'>support@mote.com</Link>
        </>
      ),
      icon: <img src={NON_IDEAL_STATE_SVG} alt='Error occurred' />
    }
  }, [state])

  React.useEffect(() => {
    if (!queryParams.invoker || queryParams.invoker !== 'extension') {
      return history.push('/pricing')
    }
  }, [])

  React.useEffect(() => {
    if (isRawProductsLoading || Object.keys(products.data).length > 0) return

    if (rawProductsError || !rawProducts) {
      setState(prev => ({
        ...prev,
        loading: false,
        error: true
      }))
      return
    }

    const newProducts = new ProductData(true, rawProducts)
    setProducts(newProducts)
  }, [products, isRawProductsLoading, rawProductsError, rawProducts])

  React.useEffect(() => {
    if (rawProductsError || Object.keys(products.data).length === 0) return

    setState(prev => ({
      ...prev,
      loading: false,
      success: true
    }))

    history.push(products.buildUnlimitedCheckoutPath(1))
  }, [products])

  return (
    <OnboardingLayout skipGreeting>
      <MessageCard {...messageCardProps} />
    </OnboardingLayout>
  )
}

const Link = styled.a`
  color: #ac0ae8;
  font-size: 15px;
  font-weight: 500;

  &:hover,
  &:focus,
  &:visited {
    color: #ac0ae8;
  }

  &:hover {
    text-decoration: none;
  }
`
